export default "__VITE_ASSET__CgkjsMzy__"